import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import "../index.css";

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is SynergySoft and what services do you provide?",
      answer:
        "SynergySoft is your trusted partner for domain registration, hosting, and managed server solutions. We provide scalable and reliable hosting services tailored to businesses of all sizes.",
    },
    {
      question: "Can I upgrade my hosting plan later?",
      answer:
        "Absolutely! You can upgrade or downgrade your hosting plan at any time without downtime. Your data and configurations remain safe.",
    },
    {
      question: "Is my website secure with SynergySoft?",
      answer:
        "Yes! All our hosting plans include free SSL certificates, automatic backups, and real-time malware protection to ensure your website stays secure at all times.",
    },
    {
      question: "Do you provide 24/7 technical support?",
      answer:
        "Yes, our expert support team is available 24/7 via chat and email to help you with any technical issues or configuration assistance.",
    },
    {
      question: "What is web hosting and how does it work?",
      answer:
        "Web hosting is a service that stores your website’s files (HTML, CSS, images, etc.) on servers. When someone visits your domain, the server delivers those files to their browser.",
    },
    {
      question: "What are the different types of hosting?",
      answer:
        "Common types include Shared Hosting, Dedicated Hosting, Windows Hosting, and Managed Hosting. Each offers different levels of control, cost, and performance.",
    },
    {
      question: "How do I choose the right hosting plan for me?",
      answer:
        "Look at your site's expected traffic, resource usage (CPU, RAM), storage needs, and budget. Start small, and upgrade as your site grows.",
    },
    {
      question: "Do I need to purchase domain and hosting from the same provider?",
      answer:
        "Not necessarily. You can register your domain with one company and host with another. But it’s often more convenient to keep them together for management simplicity.",
    },
    {
      question: "How much does hosting cost?",
      answer:
        "Cost depends on type (shared, dedicated) and features (bandwidth, storage, support). Basic shared hosting may cost a few dollars/month, while advanced setups cost more.",
    },
    {
      question: "What is bandwidth and how much do I need?",
      answer:
        "Bandwidth is the amount of data your site can transfer to visitors. If your site has many images, videos or high traffic, you'll need more bandwidth.",
    },
    {
      question: "Can I host multiple websites under one plan?",
      answer:
        "Yes, many hosting plans allow hosting multiple domains/websites under one account, as long as resources permit.",
    },
    {
      question: "What is uptime guarantee and how important is it?",
      answer:
        "Uptime guarantee refers to how often your site stays online. We aim for 99.9% uptime or more — high uptime is critical so your site is always accessible.",
    },
    {
      question: "How often do you back up my site?",
      answer:
        "We run daily backups. You can also access previous backups for recovery. We recommend keeping your own local copy too.",
    },
    {
      question: "Can I migrate my site to SynergySoft from another host?",
      answer:
        "Yes, we provide free or assisted migration services. We’ll move your files, databases, and settings with minimal downtime.",
    },
    {
      question: "Will I get email accounts with my hosting?",
      answer:
        "Yes, most of our hosting plans come with email accounts, so you can use addresses like you@yourdomain.com.",
    },
    {
      question: "What happens if my site exceeds resource limits?",
      answer:
        "If your site exceeds CPU, memory, or bandwidth limits, you may be asked to upgrade or we may throttle performance. We’ll notify you beforehand.",
    },
    {
      question: "Do you offer a control panel (like cPanel)?",
      answer:
        "Yes, we provide an easy-to-use control panel where you can manage domains, files, databases, email, and settings.",
    },
    {
      question: "What is DNS and do I need to manage it?",
      answer:
        "DNS (Domain Name System) maps your domain name to your hosting server’s IP address. We manage DNS for you, but you can edit records if needed.",
    },
    {
      question: "Is technical knowledge required to use your hosting?",
      answer:
        "Not necessarily. For basic websites, you can use our one-click installers and dashboard. But for custom development, some technical skill helps.",
    },
  ];


 const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-[#f8faff]">
      {/* Banner Section */}
      <section className="w-full relative bg-[linear-gradient(160deg,#1e40af_0%,#0891b2_100%)] text-white py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-blue-100">
            Got questions? We’ve got answers. Here are some of the most common
            queries from our customers.
          </p>
        </div>
      </section>

      {/* FAQ List Section */}
      <div className="max-w-4xl mx-auto py-16 px-4 md:px-6 space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden transition-all duration-300"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-left px-6 py-5 focus:outline-none hover:bg-blue-50 transition-all duration-200"
            >
              <span className="font-medium text-gray-800 text-lg">
                {faq.question}
              </span>
              <span className="text-blue-500 transition-transform duration-300">
                {activeIndex === index ? <Minus /> : <Plus />}
              </span>
            </button>

            <div
              className={`px-6 pb-5 text-gray-600 text-base leading-relaxed transition-all duration-300 ${
                activeIndex === index
                  ? "max-h-40 opacity-100"
                  : "max-h-0 opacity-0 overflow-hidden"
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}